"use strict"

import { Data } from '@/lib/core/components/data/data'
import * as storage from '@/lib/storage'
import { dialog } from '@/lib/core/components/dialog'
import { multilines } from '@/lib/core/components/data/form/multilines'
import { FieldText } from '@/lib/core/components/data/form/FieldText'
import { FieldSelect } from '@/lib/core/components/data/form/FieldSelect'
import { FieldLinkSimple } from '@/lib/core/components/data/form/FieldLinkSimple'
import { FieldMap } from '@/lib/core/components/data/form/FieldMap'
import { FieldStorage } from '@/lib/core/components/data/form/FieldStorage'
import { TerrenosDM } from '@/lib/core/terrenos/terrenos'
import { FotosDM } from '@/lib/core/maps/fotos'

import * as jsf from '@/lib/js_functions'

export class Visitas extends Data {
  #ref
  #Logic
  #custom
  #dataId
  constructor({ ref, Logic, custom }) {
    super({ module: 'data', dataId: custom?.dataId || 'visitas', Logic, originClass: Visitas })
    this.#ref = ref
    this.#Logic = Logic
    this.#custom = custom
    this.#dataId = custom?.dataId || 'visitas'
  }
  build = async ({ register, fields }) => {
    const specialFields = {
      terreno: TerrenoLinkSimple,
      poligono: VisitasFieldMap,
      fotos: FotosMultilines,
      ['fotos.labelMarcador']: FotosLabelMarcadorText,
      ['fotos.mostrarNoMapa']: FotosMostrarNoMapaSelect,
      ['fotos.foto']: FotosFotoFieldStorage,
      ['fotos.nome']: FotosNomeText,
      ['fotos.informacoes']: FotosInformacoesText,
      ['fotos.lat']: FotosLatText,
      ['fotos.lng']: FotosLngText
    }
    await this.form.build({ register, fields, specialFields })
    return this
  }
  // updateURLsImagensPoligonos({ register }) {
  //   if (!register.poligono) return
  //   register.poligono.map(async poligono => {
  //     if (typeof poligono === 'object' && !Array.isArray(poligono)) {
  //       const foto = register.fotos?.find(foto => foto.id == poligono.info?.id)
  //       if (foto) {
  //         // await this.getImage({ _id: register._id, fileName: foto.foto })
  //         poligono.info.foto = await storage.downloadFile({ module: 'data', dataId: 'visitas', _id: register._id, folder: 'fotos', fileName: foto.foto, early: true })
  //       }
  //     }
  //   })
  // }
}

export class TerrenoLinkSimple extends FieldLinkSimple {
  #form
  #Logic
  constructor({ form, register, fields, name = 'terreno', Logic }) {
    super({ form, register, fields, name, Logic, originClass: TerrenoLinkSimple })
    this.#form = form
    this.#Logic = Logic
  }
  async change() {
    window.showOverlay()
    const terrenos = await new TerrenosDM({ Logic: this })
    await terrenos
      .form
      .readRegister({
        query: { _id: this.value },
        project: { poligono: 1 }
      })
    this.#form.poligono.value = terrenos.form.register.poligono
    const objects = await terrenos.getMapObject({ optionsType: 'list' })
    this.#form.poligono.insertObjects({ objects })
    this.#form.poligono.fitBounds({ objects })
    window.hideOverlay()
  }
}

export class VisitasFieldMap extends FieldMap { // Class to personalise terreno FieldMap
  #ref
  #form
  #register
  #fields
  #poligono
  #Logic
  #dataId
  constructor({ ref, form, register, fields, name = 'poligono', div, Logic, dataId }) {
    super({
      ref,
      form,
      register,
      fields,
      name,
      field: jsf.getJSONObject({ fields, name: 'poligono' }),
      div,
      Logic,
      originClass: VisitasFieldMap
    })
    this.#ref = ref
    this.#form = form
    this.#register = register
    this.#fields = fields
    this.#Logic = Logic
    this.#dataId = dataId
  }
  async start() {
    await this.addAllFotos({ lines: this.#form.fotos.lines })
  }
  clickMap({ event }) {
    this.#addFotoByClickOnMap({ event })
  }
  getMarkerIndex({ id }) {
    const findId = (element => { if (element.poligono?.length == 1) { return element.info.id == id ? true : false } })
    return this.#form.poligono.value.findIndex(findId)
  }
  async addFotoMarker({ vmodel }) {
    const coords = { lat: jsf.numberIn(vmodel.lat), lng: jsf.numberIn(vmodel.lng) }
    const register = { ...vmodel, coords: [[coords]] }
    const storageParams = { module: 'data', dataId: 'visitas', _id: this.#register._id, folder: 'fotos', fileName: vmodel.foto, early: true }
    const fotos = new FotosDM({ storageParams, register })
    const objects = await fotos.getMapObject({ optionsType: 'list' })
    super.insertObjects({ objects })
    return
  }
  async addAllFotos({ lines }) {
    const _lines = lines ? lines : this.#form.fotos.lines
    if (!_lines || _lines.length === 0) return
    await Promise.all(_lines.map(async line => {
      await this.addFotoMarker({ vmodel: line })
    }))
    super.fitAllBounds({})
  }
  removeFotoMarker({ id }) {
    super
      .objects.fotos.getObject({ value: id })
      ?.removeFromMap()
  }
  async updateMarker({ vmodel }) {
    if (this.#checkIfHasLatLng({ vmodel })) return
    this.removeFotoMarker({ id: vmodel.id })
    await this.addFotoMarker({ vmodel })
    super.fitAllBounds({})
  }
  #addFotoByClickOnMap({ event }) { // eslint-disable-line
    const coord = event.latLng
    this.#form.fotos.addLine({ mostrarNoMapa: "Sim", lat: coord.lat().toString(), lng: coord.lng().toString() })
    this.addFotoMarker({ vmodel: this.#form.fotos.lines.getLast() })
  }
  #checkIfHasLatLng({ vmodel }) { // eslint-disable-line
    if (vmodel.mostrarNoMapa != 'Sim' || !vmodel.lat || !vmodel.lng) { return true }
    else { return false }
  }
}

class FotosMultilines extends multilines {
  #form
  #register
  #Logic
  constructor({ form, register, fields, name = 'fotos', Logic }) {
    super({ form, register, fields, name, Logic, originClass: FotosMultilines })
    this.#form = form
    this.#register = register
    this.#Logic = Logic
  }
  clickAdd() {
    this.#setIdOnLastNewLine()
  }
  removeLine({ lineNumber }) {
    const remove = () => {
      this.#form.poligono.removeFotoMarker({ id: super.lines[lineNumber].id })
      !super.lines[lineNumber].foto || storage.removeFile({ module: 'data', dataId: 'visitas', _id: this.#register._id, folder: 'fotos', fileName: super.lines[lineNumber].foto, early: true })
      super.lines.del({ position: lineNumber })
    }
    if (super.field.confirmRemove == undefined || super.field.confirmRemove == false) { return remove() }
    const { openDialog, closeDialog } = window
    const confirmRemoveLineDialog = new dialog({ data: {
      title: 'Tem certeza que deseja remover a linha?',
      text: 'Esta ação é definitiva e removerá a imagem do servidor de armazenamento também!',
      buttonYes: 'Sim, pode remover!',
      buttonNo: 'Não',
      action: async () => {
        window.closeDialog()
        // check if register can be saved (required, onlyone, etc)
        remove()
        this.#form.updateRegister({
          success: {
            skipDefault: true,
            success: () => {}
          }
        })
      },
    }, openDialog, closeDialog })
    confirmRemoveLineDialog.open()
  }
  #setIdOnLastNewLine() { // eslint-disable-line
    super.lines.getLast().id = this.#getNextId()
  }
  #getNextId() { // eslint-disable-line
    if (super.lines.length <= 0) { return '1' }
    const biggestID = super.lines.reduce((maior, line) => (jsf.numberIn(line.id) > jsf.numberIn(maior.id) ? line : maior)).id
    return jsf.numberOut(jsf.numberIn(biggestID) + 1)
  }
}

class FotosLabelMarcadorText extends FieldText {
  #form
  #Logic
  constructor({ form, register, fields, multiline = 'fotos', name = 'labelMarcador', Logic }) {
    super({ form, register, fields, multiline, name, Logic, originClass: FotosLabelMarcadorText })
    this.#form = form
    this.#Logic = Logic
  }
  keyup({ vmodel }) {
    this.#form.poligono.updateMarker({ vmodel })
  }
}

class FotosMostrarNoMapaSelect extends FieldSelect {
  #form
  #Logic
  constructor({ form, register, fields, multiline = 'fotos', name = 'mostrarNoMapa', Logic }) {
    super({ form, register, fields, multiline, name, Logic, originClass: FotosMostrarNoMapaSelect })
    this.#form = form
    this.#Logic = Logic
  }
  async change({ vmodel }) {
    vmodel.mostrarNoMapa == 'Sim'
      ? await this.#form.poligono.addFotoMarker({ vmodel })
      : this.#form.poligono.removeFotoMarker({ id: vmodel.id })
  }
}

class FotosFotoFieldStorage extends FieldStorage {
  #form
  #register
  #Logic
  constructor({ form, register, fields, multiline = 'fotos', name = 'foto', Logic }) {
    super({ form, register, fields, multiline, name, Logic, originClass: FotosFotoFieldStorage })
    this.#form = form
    this.#register = register
    this.#Logic = Logic
  }
  async metadados({ vmodel, metadados }) {
    window.showOverlay()
    if (this.#checkIfHasNoMetadados({ metadados, vmodel })) return
    this.#form.poligono.removeFotoMarker({ id: vmodel.id })
    this.#setCoordsInLine({ vmodel, lat: metadados?.latitude || '', lng: metadados?.longitude || '' })
    await this.#changeMostrarNoMapa({ vmodel })
    this.#form.poligono.fitAllBounds({})
    window.hideOverlay()
  }
  #checkIfHasNoMetadados({ metadados, vmodel }) { // eslint-disable-line
    if (!metadados) {
      window.$showAlert({ type: 'warning', text: 'Foto sem metadados', dismissible: true })
      return true
    }
    if (!metadados?.latitude || !metadados?.longitude) {
      this.#setLatLng({ vmodel, id: vmodel.id })
      window.$showAlert({ type: 'warning', text: 'Foto sem localização', dismissible: true })
      return true
    }
    return false
  }
  #setLatLng({ vmodel, id }) { // eslint-disable-line
    if (this.#checkIfHasLatLng({ vmodel })) return
    const index = this.#form.poligono.getMarkerIndex({ id })
    if (index == -1) { return  this.#form.poligono.addFotoMarker({ vmodel }) }
    this.#form.poligono.value[index].poligono[0].lat = vmodel.lat
    this.#form.poligono.value[index].poligono[0].lng = vmodel.lng
    this.#form.poligono.removeFotoMarker({ id })
    this.#form.poligono.addFotoMarker({ vmodel })
  }
  #checkIfHasLatLng({ vmodel }) { // eslint-disable-line
    if (vmodel.mostrarNoMapa != 'Sim' || !vmodel.lat || !vmodel.lng) { return true }
    else { return false }
  }
  #setCoordsInLine({ vmodel, lat, lng }) { // eslint-disable-line
    vmodel.lat = `${lat}`
    vmodel.lng = `${lng}`
  }
  async #changeMostrarNoMapa({ vmodel }) { // eslint-disable-line
    vmodel.mostrarNoMapa == 'Sim'
      ? await this.#form.poligono.addFotoMarker({ vmodel })
      : this.#form.poligono.removeFotoMarker({ id: vmodel.id })
  }
}

class FotosNomeText extends FieldText {
  #form
  constructor({ form, register, fields, multiline = 'fotos', name = 'nome', Logic }) {
    super({ form, register, fields, multiline, name, Logic, originClass: FotosNomeText })
    this.#form = form
  }
  change({ vmodel }) {
    this.#form.poligono.updateMarker({ vmodel })
  }
}

class FotosInformacoesText extends FieldText {
  #form
  constructor({ form, register, fields, multiline = 'fotos', name = 'informacoes', Logic }) {
    super({ form, register, fields, multiline, name, Logic, originClass: FotosInformacoesText })
    this.#form = form
  }
  change({ vmodel }) {
    this.#form.poligono.updateMarker({ vmodel })
  }
}

class FotosLatText extends FieldText {
  #form
  constructor({ form, register, fields, multiline = 'fotos', name = 'lat', Logic }) {
    super({ form, register, fields, multiline, name, Logic, originClass: FotosLatText })
    this.#form = form
  }
  change({ vmodel }) {
    this.#form.poligono.updateMarker({ vmodel })
  }
}

class FotosLngText extends FieldText {
  #form
  constructor({ form, register, fields, multiline = 'fotos', name = 'lng', Logic }) {
    super({ form, register, fields, multiline, name, Logic, originClass: FotosLngText })
    this.#form = form
  }
  change({ vmodel }) {
    this.#form.poligono.updateMarker({ vmodel })
  }
}